module.exports = new __parcel__URL__("jackie-chan-stuntmaster.f837a5ea.jpg").toString();